import * as React from 'react';
import SwiperCore, { Navigation, Pagination } from 'swiper';
import { NavigationOptions } from 'swiper/types/components/navigation';
import { Swiper, SwiperSlide } from 'swiper/react';
import classNames from 'classnames';

import * as styles from './styles.css';
import * as navStyles from './components/Navigation/styles.css';
import './swiper.css';

import { INavigationRef, Navigation as NavigationComponent } from './components/Navigation';

interface ISwiperCarouselProps extends Swiper {
  children: React.ReactElement[];
  className?: string;
}

SwiperCore.use([Navigation, Pagination]);

export function SwiperCarousel({ className, navigation, children, ...swiperOptions }: ISwiperCarouselProps) {
  const swiperRef = React.useRef<SwiperCore | null>(null);
  const navigationRef = React.useRef<INavigationRef>(null);

  React.useEffect(() => {
    if (navigation && swiperRef.current && navigationRef.current) {
      const navigationOptions: NavigationOptions = {
        ...(swiperRef.current.params.navigation as NavigationOptions),
        nextEl: navigationRef.current.next,
        prevEl: navigationRef.current.prev,
        disabledClass: navStyles['disabled'],
      };

      Object.assign(swiperRef.current.params, { navigation: navigationOptions });
      swiperRef.current.navigation.init();
      swiperRef.current.navigation.update();
    }
  }, [navigation]);

  return (
    <div className={classNames(styles['swiper_wrapper'], `${className}_wrapper`)}>
      <div className={styles[`swiper_pag`]} />
      {navigation && <NavigationComponent ref={navigationRef} className={styles['swiper_nav']} />}
      <Swiper
        className={className}
        slidesPerView={3}
        onSwiper={swiper => (swiperRef.current = swiper)}
        pagination={{
          clickable: true,
          el: `.${className}_wrapper .${styles['swiper_pag']}`,
        }}
        {...swiperOptions}
      >
        {React.Children.map(children, child => (
          <SwiperSlide className={styles['slide']}>{child}</SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
